import React, { useContext, useEffect, useRef, useState } from 'react'
import Conditional from '../common/Conditional'
import WorkplaceQuizContext from './context/WorkplaceQuizContext'
import WorkplaceQuizModuleMenuRow from './WorkplaceQuizModuleMenuRow'

export interface IWorkplaceQuizModuleMenuProps {
  isOpen: boolean
  startQuiz: (id: number) => void
  viewResult: () => void
}

const WorkplaceQuizModuleMenu = (props: IWorkplaceQuizModuleMenuProps) => {
  const mountedRef = useRef(false)
  const context = useContext(WorkplaceQuizContext)
  const [open, setOpen] = useState(false)
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    mountedRef.current = true
    if (mountedRef.current) {
      setOpen(props.isOpen)
      setIsLoading(false)
    }
    return () => {
      mountedRef.current = false
    }
  }, [props.isOpen])

  return (
    <Conditional if={!isLoading}>
      <div className={open ? 'contentMenu open' : 'contentMenu'}>
        <div id="quickMenu" tabIndex={-1} className="quickMenuListArea">
          <WorkplaceQuizModuleMenuRow
            title="Home"
            id={0}
            startQuiz={props.startQuiz}
          />
          {context.currentState?.quizStatus.map((item, index) => {
            return (
              <WorkplaceQuizModuleMenuRow
                key={index}
                title={item.title}
                id={item.quizId}
                startQuiz={props.startQuiz}
              />
            )
          })}
          <button
            tabIndex={0}
            onClick={() => props.viewResult()}
            onKeyUp={(event) => {
              if (event?.keyCode == '13') {
                props.viewResult()
              }
            }}
          >
            Results and resources
          </button>
        </div>
      </div>
    </Conditional>
  )
}
export default WorkplaceQuizModuleMenu
